import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import Boolean from './types/Boolean';
import Auto from './types/Auto';
import Real from './types/Real';
import TextFixed from './types/TextFixed';
import Text from './types/Text';
import Options from './types/Options';
import Date from './types/Date';
import DateTime from './types/DateTime';
import Time from './types/Time';
import Local from './types/Local';
import Photo from './types/Photo';
import Action from './types/Action';
import Sign from './types/Sign';
import File from './types/File';
import Multi from './types/Multiselection';
import Temp from './types/Bluetooth';

import { types } from '../../../const/types.task';

class Field extends React.Component {
    render() {
        const { data, last, hide, editable, parentDeactivated } = this.props;
        //data.modoTest = true;
        if (data.oculto ||
            (hide &&
                ((data.valor !== undefined &&
                    data.valor !== '' &&
                    data.valor !== null &&
                    data.valor.toString().length > 0 &&
                    data.valor.toString() !== '[]') ||
                    data.desactivado))
        ) {
            return <div />;
        } else {
            switch (data.type) {
                case types.boolean:
                    return (
                        <Boolean
                            data={data}
                            last={last}
                            editable={editable}
                            parentDeactivated={parentDeactivated}
                        />
                    );
                case types.action:
                    return (
                        <Action
                            data={data}
                            last={last}
                            editable={editable}
                            parentDeactivated={parentDeactivated}
                        />
                    );
                case types.number:
                case types.real:
                    return (
                        <Real
                            data={data}
                            last={last}
                            editable={editable}
                            parentDeactivated={parentDeactivated}
                        />
                    );
                case types.textfixed:
                    return (
                        <TextFixed
                            data={data}
                            last={last}
                            editable={editable}
                            parentDeactivated={parentDeactivated}
                        />
                    );
                case types.text:
                    return (
                        <Text
                            data={data}
                            last={last}
                            editable={editable}
                            parentDeactivated={parentDeactivated}
                        />
                    );
                case types.options:
                    return (
                        <Options
                            data={data}
                            last={last}
                            editable={editable}
                            parentDeactivated={parentDeactivated}
                        />
                    );
                case types.date:
                    return (
                        <Date
                            data={data}
                            last={last}
                            editable={editable}
                            parentDeactivated={parentDeactivated}
                        />
                    );
                case types.datetime:
                    return (
                        <DateTime
                            data={data}
                            last={last}
                            editable={editable}
                            parentDeactivated={parentDeactivated}
                        />
                    );
                case types.time:
                    return (
                        <Time
                            data={data}
                            last={last}
                            editable={editable}
                            parentDeactivated={parentDeactivated}
                        />
                    );
                case types.local:
                    return (
                        <Local
                            data={data}
                            last={last}
                            editable={editable}
                            parentDeactivated={parentDeactivated}
                        />
                    );
                case types.photo:
                    return (
                        <Photo
                            data={data}
                            last={last}
                            editable={editable}
                            parentDeactivated={parentDeactivated}
                        />
                    );
                case types.file:
                    return (
                        <File
                            data={data}
                            last={last}
                            editable={editable}
                            parentDeactivated={parentDeactivated}
                        />
                    );
                case types.signature:
                    return (
                        <Sign
                            data={data}
                            last={last}
                            editable={editable}
                            parentDeactivated={parentDeactivated}
                        />
                    );
                case types.multioption:
                    return (
                        <Multi
                            data={data}
                            last={last}
                            editable={editable}
                            parentDeactivated={parentDeactivated}
                        />
                    );
                case types.temp:
                    return (
                        <Temp
                            data={data}
                            last={last}
                            editable={editable}
                            parentDeactivated={parentDeactivated}
                        />
                    );
                case types.auto:
                    return (
                        <Auto
                            data={data}
                            last={last}
                            editable={editable}
                            parentDeactivated={parentDeactivated}
                        />
                    );
                default:
                    return <div />;
            }
        }
    }
}

Field.propTypes = {
    instance: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
    return {
        instance: state.instance,
    };
};

Field = connect(
    mapStateToProps,
    null,
)(Field);

export default Field;



// WEBPACK FOOTER //
// ./src/components/complex/forms/Field.js